export default function scope(state) {
  const { scope } = state

  return scope
}



// WEBPACK FOOTER //
// ./src/config-builders/project/reducers/scope.js